import { NavLink } from 'react-router-dom';

import useTranslation from 'customHooks/translate';

import { profileLinks } from './profileLinks';

interface IProps {
  isSubUser: boolean;
}

const ProfileSidebar = ({ isSubUser }: IProps) => {
  const translation = useTranslation();

  return (
    <div className="no-scrollbar flex flex-row gap-[4px] overflow-x-auto bg-white md:flex-col md:overflow-x-visible px-[16px] md:px-[32px] md:py-[23px]">
      {profileLinks(translation, isSubUser)?.map((profileLink) => (
        <NavLink
          key={profileLink?.url}
          to={profileLink?.url}
          className={({ isActive }) =>
            `max-w flex transform-none items-center p-[10px] text-center text-[14px] font-normal no-underline md:rounded-[10px] md:px-[14px] md:py-[12px] md:text-left md:text-[16px]
     ${
       isActive
         ? 'border-b-[2px] border-b-[#466AFB] md:bg-[#466AFB] md:text-white md:hover:text-white'
         : 'border-b-[2px] border-b-[transparent]'
     }`
          }
        >
          {profileLink?.name}
        </NavLink>
      ))}
    </div>
  );
};

export default ProfileSidebar;
